// extracted by mini-css-extract-plugin
module.exports = {"boton":"styles_boton__tpUFM"};